import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAllPackageList,
  createPackage,
  updatePackage,
  deletePackage
} from '../../modules/package'
import { getAllTierFeatureList } from '../../modules/tierFeature'

import {
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag,
  Tooltip
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import moment from 'moment'
import PackagesForm from './components/PackageForm'

const Packages = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { packageList, isLoading, tierFeatureList } = useSelector(
    (state) => ({
      packageList: state.packege.packageList,
      isLoading: state.packege.isLoading,
      tierFeatureList: state.tierFeature.tierFeatureList
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getAllPackageList())
      await dispatch(getAllTierFeatureList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => {
    await dispatch(getAllPackageList())
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(getAllPackageList())
    await setVisible(false)
  }

  const onDelete = async (id) => {
    await dispatch(deletePackage(id))
    await dispatch(getAllPackageList())
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updatePackage(data))
    } else {
      await dispatch(createPackage(data))
    }

    await dispatch(getAllPackageList())
    setVisible(false)
    setFormData({})
  }

  const columns = [
    {
      title: 'ชื่อแพ็กเกจ',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },

    {
      title: 'รายละเอียด',
      dataIndex: 'detail',
      key: 'detail',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150
          }
        }
      },
      width: 300,
      render: (detail) => (
        <Tooltip title={detail}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {detail}
          </div>
        </Tooltip>
      )
    },
    {
      title: 'ประเภท',
      dataIndex: 'packageType',
      key: 'packageType',
      width: 120,
      filters: [
        { text: 'แพ็กเกจหลัก', value: 'MAIN' },
        { text: 'แพ็กเกจเสริม', value: 'ADDON' }
      ],
      filterIcon: (filtered) => (
        <Icon
          type="filter"
          style={{ color: filtered ? '#1890ff' : undefined }}
        />
      ),
      onFilter: (value, record) => (record.packageType || 'MAIN') === value,
      render: (packageType) =>
        packageType === 'ADDON' ? (
          <Tag color="blue">แพ็กเกจเสริม</Tag>
        ) : (
          <Tag color="geekblue">แพ็กเกจหลัก</Tag>
        )
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      width: 100
    },
    {
      title: 'ราคาเต็ม',
      dataIndex: 'maxPrice',
      key: 'maxPrice',
      width: 100
    },
    {
      title: 'ระยะเวลา(วัน)',
      dataIndex: 'time',
      key: 'time',
      width: 115
    },
    {
      title: 'สถานะ',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 100,
      render: (isActive) => {
        return isActive ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        )
      }
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      sorter: (a, b) => moment(b.createdAt) - moment(a.createdAt), // ✅ เรียงจากล่าสุดไปเก่าสุด
      //  defaultSortOrder: 'ascend', // ✅ ตั้งค่าเริ่มต้นให้เรียงจากมากไปน้อย
      render: (date) => (
        <span>{moment(date).format('DD/MM/YYYY HH:mm:ss')}</span>
      )
    },
    {
      title: 'วันที่แก้ไขล่าสุด',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 150,
      render: (date) => (
        <span>{moment(date).format('DD/MM/YYYY HH:mm:ss')}</span>
      )
    },
    {
      title: 'remark',
      dataIndex: 'remark',
      key: 'remark',
      width: 100,
      render: (text) => (text === null ? '-' : text)
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Package List"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            เพิ่มแพ็กเกจ
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1300 }}
        rowKey={(record) => record.id}
        dataSource={packageList}
        columns={columns}
      />
      <PackagesForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
        tierOptions={(tierFeatureList || []).map((row) => row.tier)}
      />
    </Card>
  )
}

export default compose(withApollo)(Packages)
